<template>
  <transition name="playlist">
    <div class="video-item">
      <series-result-item
        v-if="item.type && item.type === 'series'"
        :item="item"
      >
        {{ item.pagetitle }}
      </series-result-item>
      <div v-else>
        <div class="item-overlay">
          <was-watched :video="`${item.id}`"></was-watched>
          <div>
            <star-video :video="item"></star-video>
          </div>
        </div>

        <router-link :to="{ name: 'video', params: { vid: this.item.id } }"
          ><img :src="imgUrl" :alt="item.pagetitle" class="video-img" />
          <div class="play-icon">
            <img
              :src="
                this.$store.state.initialData.basepath +
                'assets/yoga/images/play-icon.png'
              "
            />
          </div>

          <div class="video-info">
            <div>
              <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
                <path
                  fill="currentColor"
                  d="M12 20C16.4 20 20 16.4 20 12S16.4 4 12 4 4 7.6 4 12 7.6 20 12 20M12 2C17.5 2 22 6.5 22 12S17.5 22 12 22C6.5 22 2 17.5 2 12C2 6.5 6.5 2 12 2M17 13.9L16.3 15.2L11 12.3V7H12.5V11.4L17 13.9Z"
                />
              </svg>
              <span>{{ item.videoDuration }} דק’</span>
            </div>
            <div>
              <current-tag
                :current="getCurrent"
                :base="this.$store.state.initialData.basepath"
              >
              </current-tag>
            </div>
            <level-icon :level="level"></level-icon>
          </div>
          <div class="video-item-h4">
            <h4>{{ item.pagetitle }}</h4>
          </div>
          <div>
            <teacher-tag
              :teacher="getTeacher"
              :base="this.$store.state.initialData.basepath"
            >
            </teacher-tag>
          </div>
          <p class="description" v-html="abstract"></p>
          <div class="read-more">
            <svg style="width: 20px; height: 20px" viewBox="0 0 20 20">
              <path
                fill="currentColor"
                d="M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"
              />
            </svg>
          </div>
        </router-link>
      </div>
    </div>
  </transition>
</template>

<script>
import TeacherTag from "@/components/TeacherTag_v2.vue";
import CurrentTag from "@/components/CurrentTag_v2.vue";
import WasWatched from "@/components/video_page/WasWatched_v2.vue";
import LevelIcon from "@/components/levelIcon.vue";
import StarVideo from "@/components/video_page/StarVideo_v2.vue";
import SeriesResultItem from "@/components/newSearch/seriesResultItem.vue";

export default {
  name: `VideoItem`,

  props: {
    item: Object,
  },
  components: {
    CurrentTag,
    TeacherTag,
    WasWatched,
    LevelIcon,
    StarVideo,
    SeriesResultItem,
  },

  computed: {
    imgUrl() {
      return this.$store.state.initialData.basepath + this.item.ch;
    },
    getCurrent() {
      if (Array.isArray(this.$store.state.currents)) {
        const arr = this.$store.state.currents.filter(c => {
          if (
            typeof c.resource !== `undefined` &&
            c.resource.id === this.item.current
          ) {
            return true;
          }
          return false;
        });

        return arr[0];
      }
      return { alias: "" };
    },
    getTeacher() {
      const arr = this.$store.state.initialData.teachers.filter(t => {
        if (t.id === this.item.videoTeacher) {
          return true;
        }
        return false;
      });
      if (arr[0]) {
        return arr[0];
      }
      return { id: `` };
    },
    level() {
      if (this.$store.state.initialData.levels.length > 0) {
        const arr = this.$store.state.initialData.levels.filter(l => {
          if (l.value === this.item.videoLvl) {
            return true;
          }
          return false;
        });
        return arr[0];
      }
      return { label: `` };
    },
    abstract() {
      const str = this.item.description;
      if (str.length > 150) {
        return `${str.slice(0, 150)}...`;
      }
      return str;
    },
  },
};
</script>

<style lang="scss">
.video-item {
  margin-bottom: 30px;
  padding-bottom: 2rem;
  .video-img {
    display: block;
  }
  .video-item-h4 {
    min-height: 48px;
    padding: 0.2rem 0.5rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    h4 {
      font-size: 16px;
      font-weight: bold;
      min-height: 0;
      margin: 0;
      padding: 0;
    }
  }
  p.description {
    padding: 0 1.2rem;
    font-size: 0.9rem;
  }
  .video-info {
    background-color: #f7f7f7;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.3rem;
    color: #838383;
    svg {
      position: relative;
      top: 6px;
      margin: 0 2px;
      transform: scale(0.8);
    }
    img {
      transform: scale(0.8);
      position: relative;
      top: 5px;
    }
  }
  a {
    color: #000000;
  }
  .item-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    display: none;
    justify-content: space-between;
    padding: 0.5rem;
    z-index: 30;

    img {
      transform: scale(1.2);
    }
  }
  &:hover {
    .item-overlay {
      display: flex;
    }
  }
  .read-more {
    width: 100%;
    position: absolute;
    bottom: 0;
  }
}
</style>
